<template>
  <div class="actions_sb">
    <div class="actions_sb__title">
      <h4> {{ translate("simcard_profile.simcard_management") }} </h4>
      <div v-if="show_actions">
        <div class="spinner">
          <scale-loader />
        </div>
      </div>
    </div>

    <div v-if="!show_actions" >
      <div class="buttons_list">
        <template v-for="(service, service_index) in actions_ServiceBridge">
          <ActionButton
              v-for="(action, index) in service"
              :key="service_index + index"
              class="item"
              :action_data="action"
              :profile="profile"
              :service_name='service_index'
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from './ActionButton.vue'

export default {
  name: 'ActionsSB',
  components: {
    ActionButton
  },

  props: ['sim_id', 'profile'],

  data () {
    return {
      list_new_actions: [],
      actions_ServiceBridge: {},
      actions_status: true,
      error: false,
      loading: true,
      reload: false,
      all_data: {}
    }
  },

  computed:{
    show_actions(){
      return Object.keys(this.list_new_actions).length < 1
    }
  },

  destroyed() {
    this.$store.dispatch("WS_Unsubscribe",`simcard_profile_action_list.${this.sim_id}`)
  },

  created () {
    this.get_actions()

    if(this.$store.getters.WsGetStatus) {
      this.subscribe()
    }
  },

  methods: {
    subscribe(){
      this.$store.dispatch("WS_Subscribe",{ topic: `simcard_profile_action_list.${this.sim_id}`, func: this.ActionsFromServiceBridge, timeout: 0 })
    },
    get_actions(){
      if (this.$route.name === 'simcard_profile_section') {
        this.$http.simcard.getSimcardActions(this.sim_id, (response) => {
          if (!response.data.actions) {
            this.global_notify('danger', this.translate('simcard.no_action'))
          }
          this.actions_old = response.data.actions
          this.reload = this.actions_old.length < 1 && this.actions_status;

          this.loading = false
        })
      }
    },
    ActionsFromServiceBridge(cmd){
      if(cmd.data?.result.actions.length > 0) {
        this.actions_ServiceBridge[cmd.data?.service_name] = cmd.data?.result.actions
        let temp_arr = []
        for (let service_name in this.actions_ServiceBridge) {
          temp_arr = temp_arr.concat(this.actions_ServiceBridge[service_name])
        }
        this.list_new_actions = temp_arr
      }
    },
  },

}
</script>
<style lang="scss" scoped>
.actions_sb{
  margin: 10px 0;
  &__title{
    margin-bottom: 10px;
    h4{
      font-size: 12px;
      line-height: 120%;
      font-weight: bold;
      color: #252422;
      margin: 0;
    }
  }
  .response_table{
    height: auto;
  }
  .buttons_list{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
  }
}

</style>
